import { aboutDoors }     from './aboutDoors';
import { catalog }        from './catalog';
import { contacts }       from './contacts';
import { cookieSettings } from './cookieSettings';
import { compare }        from './compare';
import { dealer }         from './dealer';
import { developer }      from './developer';
import { guarantee }      from './guarantee';
import { homePage }    from './homePage';
import { information } from './information';
import { loginPage }   from './loginPage';
import { news }           from './news';
import { promotions }     from './promotions';
import { sitemap }        from './sitemap';
import { staticPage }     from './static';
import { user }           from './user';
import { vacancies }      from './vacancies';
import { verification }   from './verification';
import { whereBuy }       from './whereBuy';

export const templates = {
  'about':                    staticPage,
  'agreement':                staticPage,
  'certificates':             staticPage,
  'certificates_interior':    staticPage,
  'cookie':                   staticPage,
  'cookies-policy':           staticPage,
  'cookies-list':             staticPage,
  'delivery':                 staticPage,
  'designers':                staticPage,
  'developers':               staticPage,
  'dobory':                   staticPage,
  'documentation':            staticPage,
  'how-choice-door':          staticPage,
  'how-choice-door_interior': staticPage,
  'pay':                      staticPage,
  'placement':                staticPage,
  'policy-personal-data':     staticPage,
  'protection':               staticPage,
  'protection_interior':      staticPage,
  'public_offer':             staticPage,
  'static':                   staticPage,
  'zamer':                    staticPage,

  'about-doors':                       aboutDoors,
  'about-interior-doors':              aboutDoors,
  'akcii':                             promotions,
  'compare':                           compare,
  'contacts':                          contacts,
  'cookie-settings':                   cookieSettings,
  'dealer':                            dealer,
  'developer':                         developer,
  'guarantee':                         guarantee,
  'guarantee_interior':                guarantee,
  'home':                              homePage,
  'login-page':                        loginPage,
  'mezhkomnatnye-dveri':               catalog,
  'news':                              news,
  'questions':                         information,
  'questions_interior':                information,
  'sitemap':                           sitemap,
  'terminology':                       information,
  'terminology_interior':              information,
  'vacancies':                         vacancies,
  'verification':                      verification,
  'vhodnye-dveri':                     catalog,
  'where-buy':                         whereBuy,
  ...user,
};